import { render, staticRenderFns } from "./RuleGoCodeEditor.vue?vue&type=template&id=6cdf6a32"
import script from "./RuleGoCodeEditor.vue?vue&type=script&lang=js"
export * from "./RuleGoCodeEditor.vue?vue&type=script&lang=js"
import style0 from "./RuleGoCodeEditor.vue?vue&type=style&index=0&id=6cdf6a32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports